import React from "react";
import BranchForm from "./BranchForm";
import { BranchFormData } from "../types/branch";
import { ModalWrapper } from "../../../../components/ModalWrapper";
import CommonButtons from "../../../../components/CommonButtons";

interface AddBranchModalProps {
  open: boolean;
  formData: BranchFormData;
  doberror: boolean;
  error: string;
  refs: any;
  updateFormData: (updates: Partial<BranchFormData>) => void;
  handleDobChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handlePincodeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  createKeyPressHandler: (ref: React.RefObject<HTMLInputElement>) => (e: React.KeyboardEvent<HTMLInputElement>) => void;
  handleBranchnamesKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onClose: () => void;
  onSubmit: () => void;
  visible: boolean;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const AddBranchModal: React.FC<AddBranchModalProps> = ({
  open,
  formData,
  doberror,
  error,
  refs,
  updateFormData,
  handleDobChange,
  handlePincodeChange,
  createKeyPressHandler,
  handleBranchnamesKeyPress,
  onClose,
  onSubmit,
  visible,
  onKeyPress,
}) => {
  if (!open) return null;

  return (
    <ModalWrapper title="Add Branch" onClose={onClose} width="max-w-xl">
      <BranchForm
        formData={formData}
        doberror={doberror}
        error={error}
        refs={refs}
        onFormChange={updateFormData}
        onDobChange={handleDobChange}
        onPincodeChange={handlePincodeChange}
        onBranchnameKeyPress={handleBranchnamesKeyPress}
        createKeyPressHandler={createKeyPressHandler}
        onKeyPress={onKeyPress}
        isEdit={false}
      />
      <div className="flex justify-end gap-6 mt-2">
        <CommonButtons className="w-36 h-10" label="Cancel" variant="outlineDanger" onClick={onClose} />
        <CommonButtons className="w-36 h-10" label="Confirm" onClick={visible ? onSubmit : undefined} disabled={!visible} />
      </div>
    </ModalWrapper>
  );
};

export default AddBranchModal;
